const $ = require("jquery");
//declare var $: any;

export class JQueryHelperService {
  constructor() { }

  public Param(input: any) {
    if (input) {
      return $.param(input);
    }
    return "";
  }

  public Unique(input: any) {
    if (input) {
      return $.unique(input);
    }
    return input;
  }

  public RemoveFromArray(input: any, removeItem: any) {
    input = $.grep(input, function (value: any) {
      return value != removeItem;
    });
    return input;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/jquery-helper.service.ts